import { Component} from '@angular/core';
import { Sort } from '@angular/material/sort';
import { ToastrService } from 'ngx-toastr';
import { AutoMlService } from 'src/app/core/service/auto-ml.service';

@Component({
  selector: 'app-auto-ml-results',
  templateUrl: './auto-ml-results.component.html',
  styleUrls: ['./auto-ml-results.component.scss']
})
export class AutoMlResultsComponent {
  
  sliderValue = 4;
  typeOfIncome:string = 'Results';
  selectedTab:string ='tab1';
  comparisonType:string='importenceScore';
  sortedData:any;
  mode:string='chart';

  constructor(
    public _autoMl:AutoMlService,
    private toast:ToastrService
  ){
    this.sortedData = this.getTableData;    
  }

  get arrays(){
    return new Array<number>(6)
  }

  renameIterate(uuid:string,name:string){
    const data = {
      name:name
    }
    this._autoMl.renameIterateName(uuid,data)
    .subscribe((res:any)=>{
      this.toast.success(res.message)
      this._autoMl.getTableDetails();
      this._autoMl.comparisonData();
    })
  }

  deleteIteration(uuid:string,i:number){
    if(uuid!==''){
      this._autoMl.deleteIteration(uuid)
      .subscribe((res:any)=>{
        this.toast.success(res.message)
        this._autoMl.iterationSet.splice(i,1);
        this._autoMl.getTableDetails();
        this._autoMl.comparisonData();
      })
    }else{
      this._autoMl.iterationSet.splice(i,1);
    }
  }

  getWidthCoValue(value:any,max:number){
    return ((Math.abs(value??0)/this._autoMl.correlationMaxValue)*max)
  }
  
  selectTab(tabName: string): void {
    this.selectedTab = tabName;
  }

  get sortedOrder(){
    let data = JSON.stringify(this._autoMl.iterationSet[this._autoMl.selectedIndex].all_columns);
    return JSON.parse(data).sort((one:any, two:any) => (one.co_value > two.co_value ? -1 : 1));
  }

  selectedTableIndex:number=0;

  pageArr=[
    5,10,25
  ];

  page=1;
  selectedPage=5;

  getTableKey =[
    'Feature',
    'rank',
    'Importance Score'
  ]

  getRankTableKey(){
    return Object.keys(this._autoMl.rankCompareTableData[0]);
  }

  getScoreTableKey(){
    return Object.keys(this._autoMl.scoreCompareTableData[0]);
  }

  get getTableData(){
    return this._autoMl.resultPreviewData[this._autoMl.selectedIndex]?.results;
  }

  get getBarData(){
    let color='';
    switch (this._autoMl.selectedIndex) {
      case 0:
        color ='#807AED';
        break;
      case 1:
        color ='#3BD6AD';
        break;
      case 2:
        color ='#3267FF';
        break;
      case 3:
        color ='#FFB300';
        break;
    
      default:
        break;
    }

    return this._autoMl.resultPreviewData[this._autoMl.selectedIndex]?.results.map((el:any)=>{
      return [{
        value:el['Importance Score'],
        color:color
      }]
    })
  }

  get getGroupData(){
    return this._autoMl.resultPreviewData[this._autoMl.selectedIndex]?.results.map((el:any)=>{
      return el.Feature;
    })
  }

  get getMaxValue(){
    return Math.max(...this._autoMl.resultPreviewData[this._autoMl.selectedIndex]?.results.map((o:any) => o['Importance Score']))
  }

  satisfyResult(){
    this._autoMl.isSatisfy = true;
    if(this._autoMl.iterationSet[this._autoMl.selectedIndex].scenarioList.length===0){
      this._autoMl.getVariableDetails();
    }
  }

  get iterationSet(){
    return this._autoMl.iterationSet.filter((el:any)=>{
      return el.compared_result.length >0
    })
  }

  get disableState(){
    return this._autoMl.iterationSet[this._autoMl.iterationSet.length-1].all_columns.filter((el:any)=>{
      return el.check
    }).length > 0
  }

  getWidth(value:any,i:number){
   return  (value/this._autoMl.scoreTableDataMaxvalue) * 70
  }

  getWidth2(value:any,i:number){
   return  (value/this._autoMl.rankTableDataMaxvalue) * 70
  }

  getBackground(item:any,value:number){
    const data = item.map((el:any)=>{return el.value}).sort((n1:any,n2:any) => n1 - n2);
    const divValue = item.length>6?item.length:6;
    return `background:rgba(93, 177, 78,${(data.indexOf(value)/divValue)!==0?(data.indexOf(value)/divValue):0.03})`;
  }

  getBackground2(item:any,value:any){
    const data = Math.max(...item.filter((el:any)=>{ return el.value!=='-'}).map((o:any) => o.value));
    const divValue = item.filter((el:any)=>{ return el.value!=='-'}).length>6?item.filter((el:any)=>{ return el.value!=='-'}).length:6;
    return `background:rgba(93, 177, 78,${((data -(value==='-'?data:value))/divValue)!==0?(data -(value==='-'?data:value))/divValue:0.03})`;
  }

  sortData(sort: Sort) {
    const data = this.getTableData;
    if (!sort.active || sort.direction === '') {
      this.sortedData = data;
      return;
    }

    this.sortedData = data.sort((a:any, b:any) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'rank':
          return this.compare(a.rank, b.rank, isAsc);
        case 'Feature':
          return this.compare(a.Feature, b.Feature, isAsc);
        case 'Importance Score':
          return this.compare(a['Importance Score'], b['Importance Score'], isAsc);
        default:
          return 0;
      }
    });
  }


compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
  
  sampleD:any[]=[
  {
    value:14,
    name:'Poverty Reduction'
  },
  {
    value:2,
    name:'GDP'
  },
  {
    value:-5,
    name:'Unemployment Rate'
  }
  ]
}
